(function () {
  'use strict';

  if (window.SizeGuideNative) return;

  var productTypes = [
    {
      name: 'Classic Tee / Premium Tee',
      image: 'https://cdn.shopify.com/s/files/1/0608/4961/9105/files/classic-tee-size.png?v=1653560885',
      imageDimension: 'https://cdn.shopify.com/s/files/1/0608/4961/9105/files/classic-tee-size-dimension.png?v=1653461953',
      header: ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'],
      rows: [
        ['Chest (Front Only)', 18, 20, 22, 24, 26, 28, 30, 32, 34],
        ['Body Length', 28, 29, 30, 31, 32, 33, 34, 35, 36]
      ],
      footer: [
        'Chest - Measured across the chest one inch below armhole when laid flat.',
        'Body Length - Measured from high point of shoulder from front.'
      ]
    },
    {
      name: 'Hoodie / Zipper Hoodie',
      image: 'https://cdn.shopify.com/s/files/1/0608/4961/9105/files/pullover-hoodie-size.png?v=1653560885',
      imageDimension: 'https://cdn.shopify.com/s/files/1/0608/4961/9105/files/pullover-hoodie-size-dimension.png?v=1653461953',
      header: ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'],
      rows: [
        ['Chest (Front Only)', 20, 22, 24, 26, 28, 29, 32, 34],
        ['Body Length', 26, 27, 28, 29, 30, 32, 33, 34],
        ['Sleeve Length', 33, 34, 35, 36, 37, 38, 39, 40]
      ],
      footer: [
        'Chest - Measured across the chest one inch below armhole when laid flat.',
        'Body Length - Measured from high point of shoulder from the back.',
        'Sleeve Length - Start at center of neck and measure down shoulder, down sleeve to hem.'
      ]
    },
    {
      name: 'Long Sleeve',
      image: 'https://cdn.shopify.com/s/files/1/0608/4961/9105/files/long-sleeve-size.png?v=1653560885',
      imageDimension: 'https://cdn.shopify.com/s/files/1/0608/4961/9105/files/long-sleeve-size-dimension.png?v=1653461953',
      header: ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'],
      rows: [
        ['Chest (Front Only)', 20, 22, 24, 26, 28, 29, 32, 34],
        ['Body Length', 26, 27, 28, 29, 30, 32, 33, 34],
        ['Sleeve Length', 33, 34, 35, 36, 37, 38, 39, 40]
      ],
      footer: [
        'Chest - Measured across the chest one inch below armhole when laid flat.',
        'Body Length - Measured from high point of shoulder from front.',
        'Sleeve - Measured from high point of shoulder to finish hem at back.'
      ]
    },
    {
      name: 'Polo Shirt',
      image: 'https://cdn.shopify.com/s/files/1/0608/4961/9105/files/classic-tee-size.png?v=1653560885',
      imageDimension: 'https://cdn.shopify.com/s/files/1/0608/4961/9105/files/classic-tee-size-dimension.png?v=1653461953',
      header: ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'],
      rows: [
        ['Chest (Front Only)', 18, 20, 22, 24, 26, 28, 30, 32, 34],
        ['Body Length', 28, 29, 30, 31, 32, 33, 34, 35, 36]
      ],
      footer: [
        'Chest - Measured across the chest one inch below armhole when laid flat.',
        'Body Length - Measured from high point of shoulder from front.'
      ]
    },
    {
      name: 'Unisex Tank Top',
      image: 'https://cdn.shopify.com/s/files/1/0608/4961/9105/files/unisex-tanktop-size.png?v=1653560885',
      imageDimension: 'https://cdn.shopify.com/s/files/1/0608/4961/9105/files/unisex-tank-top-size-dimension.png?v=1653461953',
      header: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'],
      rows: [
        ['Chest (Front Only)', 16, 18, 20, 22, 24, 26, 28, 30, 32, 34],
        ['Body Length', 27, 28, 29, 30, 31, 32, 33, 34, 35, 36]
      ],
      footer: [
        'Chest - Measured across the chest one inch below armhole when laid flat.',
        'Body Length - Measured from high point of shoulder from the back.'
      ]
    },
    {
      name: 'Sweatpants',
      image: 'https://cdn.shopify.com/s/files/1/0775/7499/6246/files/Jogger.jpg?v=1709028954',
      imageDimension: 'https://cdn.shopify.com/s/files/1/0775/7499/6246/files/Jogger2.jpg?v=1709028954',
      header: ['2XS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'],
      rows: [
        ['Waist', 22, 23.6, 25.2, 26.7, 28.3, 29.9, 31.4, 33],
        ['Hips', 29.9, 32.2, 33.8, 36.2, 38.9, 40.9, 42.4, 44.8],
        ['Length', 39.7, 40.1, 40.5, 41.3, 42.1, 42.8, 44, 44.8]
      ],
      footer: [
        'Waist - Measured around the waistband of the pants when laid flat.',
        'Hips - Measured across the widest part of the hips when laid flat.',
        'Length - Measured from the top of the waistband down to the bottom of the leg hem.'
      ]
    },
    {
      name: 'Legging',
      image: 'https://cdn.shopify.com/s/files/1/0775/7499/6246/files/legging.jpg?v=1709028954',
      imageDimension: 'https://cdn.shopify.com/s/files/1/0775/7499/6246/files/legging2.jpg?v=1709028954',
      header: ['S', 'M', 'L', 'XL', '2XL', '3XL'],
      rows: [
        ['Waist', 22.8, 24.4, 25.9, 27.5, 29.1, 30.7],
        ['Hips', 27.5, 29.1, 30.7, 32.2, 33.8, 35.4],
        ['Length', 35, 35.8, 36.5, 37.3, 38.1, 38.9]
      ],
      footer: [
        'Waist - Measured around the waistband of the pants when laid flat.',
        'Hips - Measured across the widest part of the hips when laid flat.',
        'Length - Measured from the top of the waistband down to the bottom of the leg hem.'
      ]
    },
    {
      name: 'Youth Tee',
      image: 'https://cdn.shopify.com/s/files/1/0608/4961/9105/files/youth-tee-size.png?v=1653560885',
      imageDimension: 'https://cdn.shopify.com/s/files/1/0608/4961/9105/files/youth-tee-size-dimension.png?v=1653461953',
      header: ['Youth XS', 'Youth S', 'Youth M', 'Youth L', 'Youth XL'],
      rows: [
        ['Chest (Front Only)', 16, 17, 18, 19, 20],
        ['Body Length', 20.5, 22, 23.5, 25, 26.5]
      ],
      footer: [
        'Chest - Measured across the chest one inch below armhole when laid flat.',
        'Body Length - Measured from high point of shoulder from the back.'
      ]
    },
    {
      name: 'Youth Hoodie',
      image: 'https://cdn.shopify.com/s/files/1/0608/4961/9105/files/pullover-hoodie-size.png?v=1653560885',
      imageDimension: 'https://cdn.shopify.com/s/files/1/0608/4961/9105/files/pullover-hoodie-size-dimension.png?v=1653461953',
      header: ['Youth XS', 'Youth S', 'Youth M', 'Youth L', 'Youth XL'],
      rows: [
        ['Chest (Front Only)', 16, 17, 18, 19, 20],
        ['Body Length', 20.5, 22, 23.5, 25, 26.5]
      ],
      footer: [
        'Chest - Measured across the chest one inch below armhole when laid flat.',
        'Body Length - Measured from high point of shoulder from the back.'
      ]
    },
    {
      name: 'Baby Onesie',
      image: 'https://cdn.shopify.com/s/files/1/0571/4676/9444/files/Kid_Size_Chart.jpg?v=1750746207',
      imageDimension: 'https://cdn.shopify.com/s/files/1/0571/4676/9444/files/Kid_Size_Chart-1.jpg?v=1750746207',
      header: ['NB', '6M', '12M', '18M', '24M'],
      rows: [
        ['Chest (Front Only)', 7.5, 9, 10, 11, 12],
        ['Body Length At Back', 10.8, 11.8, 12.8, 13.8, 14.8]
      ],
      footer: [
        'Chest - Measured across the chest one inch below armhole when laid flat.',
        'Body Length - Measured from high point of shoulder from the back.'
      ]
    }
  ];

  var measurementNote = '(*) There might be ±1.0 inches difference due to manual measurement and production processes';

  function createElement(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }

  function createTable(productType) {
    var frame = createElement('div', 'size-guide-native__table-frame');
    var hint = createElement('p', 'size-guide-native__scroll-hint', 'Swipe horizontally to view all sizes →');
    hint.setAttribute('aria-hidden', 'true');
    var scroll = createElement('div', 'size-guide-native__table-scroll');
    scroll.setAttribute('tabindex', '0');
    scroll.setAttribute('aria-label', productType.name + ' size chart. Scroll horizontally for more sizes.');
    var table = createElement('table');
    var head = document.createElement('thead');
    var headRow = document.createElement('tr');
    headRow.appendChild(createElement('th', '', 'Size'));
    productType.header.forEach(function (size) {
      headRow.appendChild(createElement('th', '', size));
    });
    head.appendChild(headRow);
    table.appendChild(head);

    var body = document.createElement('tbody');
    productType.rows.forEach(function (row) {
      var tableRow = document.createElement('tr');
      row.forEach(function (value, index) {
        tableRow.appendChild(createElement(index === 0 ? 'th' : 'td', '', value));
      });
      body.appendChild(tableRow);
    });
    table.appendChild(body);
    scroll.appendChild(table);
    frame.appendChild(hint);
    frame.appendChild(scroll);
    return frame;
  }

  function mount(container, options) {
    if (!container) return null;
    options = options || {};
    container.innerHTML = '';
    container.classList.add('size-guide-native');
    container.classList.remove('size-guide-native--page', 'size-guide-native--dialog');
    container.classList.add(options.context === 'dialog' ? 'size-guide-native--dialog' : 'size-guide-native--page');

    var choices = createElement('section', 'size-guide-native__choices');
    choices.setAttribute('aria-labelledby', options.headingId || 'size-guide-choose-heading');
    var choicesHeading = createElement('h2', 'size-guide-native__heading', 'Choose your product type');
    choicesHeading.id = options.headingId || 'size-guide-choose-heading';
    var grid = createElement('div', 'size-guide-native__grid');
    grid.setAttribute('role', 'tablist');
    grid.setAttribute('aria-label', 'Product type');
    choices.appendChild(choicesHeading);
    choices.appendChild(grid);

    var details = createElement('section', 'size-guide-native__details');
    details.id = (options.headingId || 'size-guide-choose-heading') + '-panel';
    details.setAttribute('role', 'tabpanel');
    var title = createElement('h2', 'size-guide-native__heading');
    var content = createElement('div', 'size-guide-native__content');
    var chartColumn = createElement('div', 'size-guide-native__chart');
    var dimension = createElement('figure', 'size-guide-native__dimension');
    content.appendChild(chartColumn);
    content.appendChild(dimension);
    details.appendChild(title);
    details.appendChild(content);
    details.setAttribute('aria-live', 'polite');

    container.appendChild(choices);
    container.appendChild(details);

    var buttons = [];

    function select(index, shouldScroll) {
      var productType = productTypes[index];
      if (!productType) return;
      buttons.forEach(function (button, buttonIndex) {
        var active = buttonIndex === index;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.setAttribute('aria-selected', active ? 'true' : 'false');
        button.tabIndex = active ? 0 : -1;
      });

      title.textContent = productType.name + ' (Inches)';
      chartColumn.innerHTML = '';
      chartColumn.appendChild(createTable(productType));
      var notes = createElement('div', 'size-guide-native__notes');
      productType.footer.concat([measurementNote]).forEach(function (note) {
        notes.appendChild(createElement('p', '', note));
      });
      chartColumn.appendChild(notes);

      dimension.innerHTML = '';
      var image = document.createElement('img');
      image.src = productType.imageDimension;
      image.alt = productType.name + ' measurement diagram';
      image.loading = 'eager';
      image.decoding = 'async';
      dimension.appendChild(image);

      if (shouldScroll && options.centerSelected && buttons[index]) {
        buttons[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      if (shouldScroll && options.scrollOnSelect && window.matchMedia('(max-width: 767px)').matches) {
        details.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    productTypes.forEach(function (productType, index) {
      var button = createElement('button', 'size-guide-native__choice');
      button.type = 'button';
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-selected', 'false');
      button.setAttribute('aria-controls', details.id);
      var image = document.createElement('img');
      image.src = productType.image;
      image.alt = '';
      image.loading = index < 2 ? 'eager' : 'lazy';
      image.decoding = 'async';
      button.appendChild(image);
      button.appendChild(createElement('span', '', productType.name));
      button.addEventListener('click', function () {
        select(index, true);
      });
      button.addEventListener('keydown', function (event) {
        var targetIndex = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          targetIndex = (index + 1) % productTypes.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          targetIndex = (index - 1 + productTypes.length) % productTypes.length;
        } else if (event.key === 'Home') {
          targetIndex = 0;
        } else if (event.key === 'End') {
          targetIndex = productTypes.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        select(targetIndex, true);
        if (buttons[targetIndex]) {
          buttons[targetIndex].focus();
        }
      });
      buttons.push(button);
      grid.appendChild(button);
    });

    select(0, false);
    return { select: select };
  }

  function mountPage() {
    var page = document.querySelector('.page.size-guide-page');
    if (page && !page.dataset.sizeGuideMounted) {
      page.dataset.sizeGuideMounted = 'true';
      mount(page, {
        context: 'page',
        scrollOnSelect: true,
        centerSelected: true,
        headingId: 'size-guide-page-heading'
      });
    }
  }

  window.SizeGuideNative = {
    mount: mount,
    productTypes: productTypes.slice()
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountPage, { once: true });
  } else {
    mountPage();
  }
})();
